import { getNbnPlanSummaryServerSideProps } from 'src/helpers/nextjs/getNbnPlanSummaryServerSideProps';
import { withServerSideAppProps } from 'src/helpers/nextjs/withServerSideAppProps';

export { default } from '../[[...slug]]';

export const getServerSideProps = withServerSideAppProps(getNbnPlanSummaryServerSideProps);
